export const BODY_TYPE_LIST = [
  { key: "default", isMobile: true },
  { key: "circle", isMobile: true },
  { key: "heart", isMobile: true },
  { key: "rounded", isMobile: true },
  { key: "two_rounded" },
  { key: "tilted_rounded" },
  { key: "star" },
  { key: "triangle" },
  { key: "hexagon" },
  { key: "sparkle" },
  { key: "danger", guest: false },
];
